import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Download, Smartphone } from 'lucide-react';
import { usePWAInstall } from '@/hooks/usePWAInstall';

export function InstallBanner() {
  const { isInstallable, isInstalled, install, dismiss } = usePWAInstall();

  // Add padding to body when banner is shown
  useEffect(() => {
    if (isInstallable && !isInstalled) {
      document.body.style.paddingBottom = '80px';
      return () => {
        document.body.style.paddingBottom = '';
      };
    }
  }, [isInstallable, isInstalled]);

  // Don't show if not installable or already installed
  if (!isInstallable || isInstalled) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 bg-primary text-primary-foreground shadow-lg border-t animate-in slide-in-from-bottom-5">
      <div className="container mx-auto">
        {/* Mobile: stacked layout */}
        <div className="flex flex-col gap-2 sm:hidden">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Smartphone className="h-4 w-4" />
              <p className="font-medium text-sm">Install QuickGrade</p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={dismiss}
              className="h-7 w-7 text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <Button
            variant="secondary"
            size="sm"
            onClick={install}
            className="w-full gap-1"
          >
            <Download className="h-4 w-4" />
            Install App
          </Button>
        </div>

        {/* Desktop: horizontal layout */}
        <div className="hidden sm:flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary-foreground/10 rounded-full">
              <Smartphone className="h-5 w-5" />
            </div>
            <div>
              <p className="font-medium text-sm">Install QuickGrade</p>
              <p className="text-xs text-primary-foreground/80">
                Add to your home screen for quick access
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="secondary"
              size="sm"
              onClick={install}
              className="gap-1"
            >
              <Download className="h-4 w-4" />
              Install
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={dismiss}
              className="h-8 w-8 text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
